import { gql } from "@apollo/client";

export const GET_PRODUCTS_LIST = gql`
  query GetProducts($input: GetProductsRequest!) {
   getProducts(input: $input) {
      products {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
    totalCount
  }
}`;

export const GET_PLATFORMS_LIST = gql`
  query GetPlatforms($input: GetPlatformsRequest!) {
    getPlatforms(input: $input) {
      platforms {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_PROJECTS_LIST = gql`    
  query GetProjects($input: GetProjectInput!) {
    getProjects(input: $input) {
      projects {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_VENDORS = gql`
  query GetVendors($input: GetVendorInput!) {
    getVendors(input: $input) {
      vendors {
        id
        name
        description
        capabilities
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_ACCOUNTS = gql`
  query GetVendorAccounts($input: GetVendorAccountInput!) {
  getVendorAccounts(input: $input) {
    vendorAccounts {
      id
      vendorId
      vendorName
      productId
      productName
      associatedDomainName
      vendorMetadata
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_USERS = gql`
  query GetVendorUsers($input: GetVendorUserInput!) {
  getVendorUsers(input: $input) {
    vendorUsers {
      id
      vendorAccountId
      associatedDomainName
      externalUserId
      userType
      roleName
      firstName
      lastName
      email
      userMetadata
      capabilities
      isUsed
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_PROJECT_USERS = gql`
  query GetVendorProjectUsers($input: GetVendorProjectUserInput!) {
  getVendorProjectUsers(input: $input) {
    vendorProjectUsers {
      id
      projects{
        id
        name
      }
      vendorId
      vendorUserId
      vendorUserName
      vendorEmail
      vendorId
      userType
      isUsed
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_LIVE_SESSIONS = gql`
  query GetLiveSessions($input: GetLiveSessionInput!) {
  getLiveSessions(input: $input) {
    liveSessions {
      id
      vendorId
      vendorName
      vendorAccountId
      vendorAccountName
      projects{
        id
        name
      }
      externalSessionId
      sessionType
      status
      scheduledStartTime
      scheduledEndTime
      actualStartTime
      actualEndTime
      sessionMetadata
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_LIVE_SESSION_INSTANCES = gql`
  query GetLiveSessionInstances($input: GetLiveSessionInstanceInput!) {
    getLiveSessionInstances(input: $input) {
      liveSessionInstances {
        id
        externalLiveSessionsInstanceId
        liveSessionId
        sortOrder
        status
        iteration
        startedAt
        endedAt
        metadata
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
  }
`;

export const GET_LIVE_SESSION_INSTANCE_RECORDED_VIDEO = gql`
  query GetLiveSessionInstanceRecordedVideo($input: GetLiveSessionInstanceRecordedVideoInput!) {
    getLiveSessionInstanceRecordedVideo(input: $input) {
      status
      message
      error_code
      recordedUrl
    }
  }
`;

export const GET_TEACHERS = gql`
  query GetTeachers($input: GetTeachersInput!) {
    getTeachers(input: $input) {
      teachers { 
        id
        employeeId
        employee{
          id
          firstName
          lastName
          email
          employeeId
        }
        employeeDepartment{
          id
          name
        }
        employeeDepartmentId
        employeeDesignation{
          id
          name
        }
        employeeDesignationId
        createdById
        updatedById
        createdByName
        updatedByName
        createdAt
        updatedAt
        isArchived
      }
      totalCount
    }
  }
`;

export const GET_SESSION_ALLOCATIONS = gql`
  query GetSessionAllocations($input: GetSessionAllocationInput!) {
    getSessionAllocations(input: $input) {
      sessionAllocations {
        id
        projects{
          id
          name
        }
        liveSessionId
        vendorUserId
        userType
        allocationStatus
        entityType
        entityId
        entityValue
        entityName
        bufferedStartTime
        bufferedEndTime
        actualStartTime
        actualEndTime
        type
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        liveSession {
          id
          externalSessionId
          sessionType
          status
          scheduledStartTime
          scheduledEndTime
        }
        vendorUser {
          id
          firstName
          lastName
          email
        }
      }
      totalCount
    }
}
`;

export const GET_SESSION_USAGES = gql`
  query GetSessionUsages($input: GetSessionUsageInput!) {
    getSessionUsages(input: $input) {
      sessionUsages {
        id
        liveSessionId
        entityType
        entityId
        entityValue
        entityName
        joinedAt
        leftAt
        timeSpentInSeconds
        hasAttended
        attendanceMetadata
        isActive
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        projects{
          id
          name
        }
        
      }
      totalCount
    }
}
`;

export const GET_LIVECLASS_PACKAGES = gql`
 query GetLiveclassPackages($input: GetLiveclassPackagesInput!) {
  getLiveclassPackages(input: $input) {
    liveclassPackages {
      id
      name
      batchId
      batchName
      gradeId
      gradeName
      branchId
      branchName
      sectionId
      sectionName
      academicYearId
      academicYearName
      streamId
      streamName
      projectId
      projectName
      packageStudentsCount
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_PACKAGE_SCHEDULES = gql`
query GetPackageSchedules($input: GetPackageScheduleInput!) {
  getPackageSchedules(input: $input) {
    packageSchedules {
      id
      liveSessionId
      status
      scheduledDurationInMin
      scheduledParticipantsCount
      meetingTitle
      meetingSubTitle
      subjectName
      thumbnailUrl
      notesUrl
      metadata
      cancelledAt
      completedAt
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
      departmentId
      employeeDepartmentName
      designationId
      employeeDesignationName
      teacherId
      teacherName
      employeeId
      vendorUserId
      vendorUserName
      vendorUserEmail
      liveclassPackages {
        id
        name
        batchId
        batchName
        gradeId
        gradeName
        branchId
        branchName
        sectionId
        sectionName
        academicYearId
        academicYearName
        streamId
        streamName
        packageStudentsCount
        isActive
      }
      liveSession {
        id
        vendorId
        vendorName
        vendorEmail
        vendorAccountId
        vendorAccountName
        projects {
          id
          name
        }
        externalSessionId
        sessionType
        status
        scheduledStartTime
        scheduledEndTime
        actualStartTime
        actualEndTime
        sessionMetadata
      }
    }
    totalCount
  }
}`;

export const GET_LIVECLASS_GROUP_PACKAGE_SUBSCRIBERS = gql`
  query GetLiveclassGroupPackageSubscribers($input: GetLiveclassGroupPackageSubscribersInput!) {
    getLiveclassGroupPackageSubscribers(input: $input) {
      liveclassGroupPackageSubscribers {
        id
        liveclassPackageId
        entityId
        isArchived
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        admissionNumber
        liveclassPackage {
          id
          name
          batchId
          batchName
          gradeId
          gradeName
          branchId
          branchName
          sectionId
          sectionName
          academicYearId
          academicYearName
          streamId
          streamName
        }
      }
      totalCount
    }
  }
`;

export const GET_EMPLOYEE_DEPARTMENTS = gql`
  query GetEmployeeDepartments($input: GetEmployeeDepartmentsInput!) {
    getEmployeeDepartments(input: $input) {
      employeeDepartments {
        id
        name
        description
        isTeaching
        isLanguage
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_EMPLOYEE_DESIGNATIONS = gql`
  query GetEmployeeDesignations($input: GetEmployeeDesignationsInput!) {
    getEmployeeDesignations(input: $input) {
      employeeDesignations {
        id
        name
        description
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_ACADEMIC_YEARS = gql`
  query GetAcademicYears($input: GetAcademicYearRequest!) {
    getAcademicYears(input: $input) {
      totalCount
      academicYears {
        name
        nlearn3AcadamicYearId
        id
      }
    }
  }
`;

export const GET_NLEARN3_BATCHES = gql`
  query GetNlearn3Batches($input: GetNlearn3BatchInput!) {
    getNlearn3Batches(input: $input) {
      nlearn3Batches {
        objectId
        batchId
        name
        isArchived
      }
      totalCount
    }
}`;

export const GET_BATCHES = gql`
query GetBatches($input: GetBatchesRequest!) {
  getBatches(input: $input) {
    totalCount
    batches {
      id
      name
    }
  }
}`;

export const GET_NLEARN3_BRANCHES = gql`
  query GetNlearn3Branches($input: GetNlearn3BranchInput!) {
    getNlearn3Branches(input: $input) {
      nlearn3Branches {
        objectId
        name
        collegeId
        isArchived
        
      }
      totalCount
    }
}`;

export const GET_BRANCHES = gql`
  query GetBranches($input: GetBranchesRequest!) {
    getBranches(input: $input) {
      totalCount
      branches {
        nlearn3BranchId
        id
        name

      }
    }
  }`;

export const GET_NLEARN3_SECTIONS = gql`
  query GetNlearn3Sections($input: GetNlearn3SectionInput!) {
    getNlearn3Sections(input: $input) {
      nlearn3Sections {
        objectId
        sectionId
        name
      }
      totalCount
    }
}`;

export const GET_SECTIONS = gql`
  query GetSections($input: GetSectionRequest!) {
    getSections(input: $input) {
      totalCount
      sections {
        id
        name
      }
    }
  }`;

export const GET_NLEARN3_STREAMS = gql`
  query GetNlearn3Streams($input: GetNlearn3StreamInput!) {
    getNlearn3Streams(input: $input) {
      nlearn3Streams {
        objectId
        streamId
        name
      }
      totalCount
    }
}`;

export const GET_STREAMS = gql`
  query GetStreams($input: GetStreamRequest!) {
    getStreams(input: $input) {
      totalCount
      streams {
        id
        name
      }
    }
  }
`;

export const GET_NLEARN3_STUDENTS = gql`
  query GetNlearn3Students($input: GetNlearn3StudentInput!) {
    getNlearn3Students(input: $input) {
      nlearn3Students {
        id
        admissionNumber
        studentName
        parentName
        phone
        email
        dob
        gender
        category
      }
      totalCount
    }
}`;

export const GET_NLEARN3_CLASSES = gql`
  query GetNlearn3Classes($input: GetNlearn3ClassInput!) {
    getNlearn3Classes(input: $input) {
      nlearn3Classes {
        objectId
        classId
        name
        isArchived
      }
      totalCount
    }
}`;

export const GET_GRADES = gql`
  query GetGrades($input: GetGradesRequest!) {
    getGrades(input: $input) {
      totalCount
      grades {
        id
        name
      }
    }
  }`;

export const GET_EMPLOYEES = gql`
query GetEmployees($input: GetEmployeeInput!) {
  getEmployees(input: $input) {
    employees {
      id
      firstName
      lastName
      employeeId
      username
      email
      gender
    }
    totalCount
  }
}`;

export const GET_LIVECLASS_MASTERS = gql`
  query GetLiveclassMasters($input: GetLiveClassMasterInput!) {
    getLiveclassMasters(input: $input) {
      liveclassMasters {
          id
          recordedVideoMaxVisibleDate
          narayanaStudentProfileId
          narayanaStudentProfileName
          admissionNumber
          narayanaAcademicYearProfileId
          narayanaAcademicYearProfileName
          userId
          userName
          academicYearId
          academicYearName
          packageId
          packageName
          packageScheduleId
          packageScheduleName
          isJoinClicked
          isWatchNowClicked
          isAttended
          createdAt
          updatedAt
          createdById
          updatedById
          createdByName
          updatedByName
      }
      totalCount
    }
  }
`;

export const GET_SESSION_ATTENDANCE_REPORT = gql`
  query GetSessionAttendanceReport($input: GetSessionAttendanceReportInput!) {
    getSessionAttendanceReport(input: $input) {
      mappedStudentCount
      presentStudentCount
      absentStudentCount
      attendancePercentage
    }
  }
`;
